/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserDto } from '../../models/center-user-dto';

export interface CenterUserControllerFindUsersByCenterId$Params {

/**
 * 센터 ID
 */
  centerId: string;

/**
 * 검색어
 */
  query?: string;

/**
 * 그룹 ID
 */
  groupId?: string;

/**
 * 바우처
 */
  vouchers?: Array<string>;

/**
 * 치료 유형
 */
  ticketTypes?: Array<string>;

/**
 * 사용자 ID
 */
  userId?: string;

/**
 * 퇴사 여부
 */
  left?: boolean;
}

export function centerUserControllerFindUsersByCenterId(http: HttpClient, rootUrl: string, params: CenterUserControllerFindUsersByCenterId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterUserDto>>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerFindUsersByCenterId.PATH, 'get');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.query('query', params.query, {});
    rb.query('groupId', params.groupId, {});
    rb.query('vouchers', params.vouchers, {});
    rb.query('ticketTypes', params.ticketTypes, {});
    rb.query('userId', params.userId, {});
    rb.query('left', params.left, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterUserDto>>;
    })
  );
}

centerUserControllerFindUsersByCenterId.PATH = '/api/center-user/{centerId}/users';
